<div class="item-browser-container">
  <!-- Toolbar with Search and Actions -->
  @if (config.showSearch || config.showCreate || config.showDateRangeFilter) {
  <div class="item-browser__toolbar">
    <div class="item-browser__search-container">
      @if (config.showSearch) {
      <div class="item-browser__search-input-container">
        <ng-glyph name="search" size="20" class="item-browser__search-icon"></ng-glyph>
        <input
          type="text"
          class="item-browser__search-input"
          [placeholder]="config.searchPlaceholder || 'Search...'"
          [value]="searchTerm"
          (input)="onSearchInput($event)" />
      </div>
      }
    </div>
    <div class="item-browser__actions-container">
      <!-- Date Range Filter Toggle Button -->
      @if (config.showDateRangeFilter) {
      <button
        class="item-browser__date-range-filter-btn"
        (click)="toggleDateRangeFilter()"
        type="button"
        [attr.title]="config.dateRangeFilterLabel || 'Filter by date range'"
        [class.item-browser__date-range-filter-btn--active]="hasDateRangeFilter()">
        <ng-glyph name="calendar_today" size="20"></ng-glyph>
      </button>
      }
      <!-- Items Per Page Selector -->
      <div class="item-browser__items-per-page">
        <span class="item-browser__items-per-page-label">Items per page</span>
        <div class="item-browser__items-per-page-select-wrap">
          <select class="item-browser__items-per-page-select" [value]="currentItemsPerPage" (change)="onItemsPerPageChange($event)">
            @for (size of itemsPerPageOptions; track size) {
            <option [value]="size" [selected]="size === currentItemsPerPage">{{ size }}</option>
            }
          </select>
          <ng-glyph class="item-browser__items-per-page-caret" name="expand_more" size="16"></ng-glyph>
        </div>
      </div>
      @if (config.showCreate) {
      <button class="item-browser__create-btn" (click)="onCreateClick()" type="button">
        <ng-glyph [name]="config.createButtonIcon || 'add'" size="20"></ng-glyph>
        <span>{{ config.createButtonLabel || "Create" }}</span>
      </button>
      }
    </div>
  </div>
  }

  <!-- Date Range Filter Dropdown -->
  @if (showDateRangeFilter) {
  <div class="item-browser__date-range-filter-dropdown">
    <div class="item-browser__date-range-filter-header">
      <h4>Filter by Date Range</h4>
      <button class="item-browser__date-range-filter-close" (click)="closeDateRangeFilter()">
        <ng-glyph name="close" size="16"></ng-glyph>
      </button>
    </div>
    <div class="item-browser__date-range-filter-body">
      <div class="item-browser__date-range-filter-group">
        <label class="item-browser__date-range-filter-label" for="dateFrom">From</label>
        <div class="item-browser__date-range-input-wrapper">
          <input
            id="dateFrom"
            type="datetime-local"
            class="item-browser__date-range-input"
            [value]="dateRangeFilter.from?.slice(0, 16) || ''"
            (change)="onDateRangeChange($event, 'from')"
            placeholder="Select from date" />
        </div>
      </div>
      <div class="item-browser__date-range-filter-group">
        <label class="item-browser__date-range-filter-label" for="dateTo">To</label>
        <div class="item-browser__date-range-input-wrapper">
          <input
            id="dateTo"
            type="datetime-local"
            class="item-browser__date-range-input"
            [value]="dateRangeFilter.to?.slice(0, 16) || ''"
            (change)="onDateRangeChange($event, 'to')"
            placeholder="Select to date" />
        </div>
      </div>
      @if (hasDateRangeFilter()) {
      <div class="item-browser__date-range-filter-actions">
        <button class="item-browser__date-range-clear-btn" (click)="clearDateRangeFilter()" type="button">
          <ng-glyph name="delete" size="16"></ng-glyph>
          <span>Clear Filter</span>
        </button>
      </div>
      }
    </div>
  </div>
  }

  <!-- Cards Grid -->
  <div class="item-browser__grid" [class.item-browser__grid--loading]="config.loading">
    @if (config.loading) {
    <div class="item-browser__loading-state">
      <ng-glyph name="refresh" size="32" class="item-browser__loading-icon" style="animation: spin 1s linear infinite"></ng-glyph>
      <span>Loading...</span>
    </div>
    } @else if (displayedData.length === 0) {
    <div class="item-browser__empty-state">
      <ng-glyph name="info" size="32" class="item-browser__empty-icon"></ng-glyph>
      <span>{{ config.emptyMessage || "No items available" }}</span>
    </div>
    } @else { @for (item of displayedData; track item) {
    <div
      class="item-browser__card"
      [class.item-browser__card--portrait]="getImageOrientation() === 'portrait'"
      [class.item-browser__card--landscape]="getImageOrientation() === 'landscape'">
      <div
        class="item-browser__card-image-container"
        [class.item-browser__card-image-container--portrait]="getImageOrientation() === 'portrait'"
        [class.item-browser__card-image-container--landscape]="getImageOrientation() === 'landscape'">
        @if (getImageUrl(item)) {
        <img [src]="getImageUrl(item)" [alt]="getCardTitle(item)" class="item-browser__card-image" />
        } @else {
        <div class="item-browser__card-image-placeholder">
          <ng-glyph name="image" size="48" class="item-browser__card-image-placeholder-icon"></ng-glyph>
        </div>
        }
      </div>
      <div class="item-browser__card-content">
        <h3 class="item-browser__card-title">{{ getCardTitle(item) }}</h3>
        @if (getCardSubtitle(item)) {
        <p class="item-browser__card-subtitle">{{ getCardSubtitle(item) }}</p>
        } @if (config.cardContentTemplate) {
        <div class="item-browser__card-body" [innerHTML]="config.cardContentTemplate(item)"></div>
        }
        <div class="item-browser__card-actions">
          @for (action of config.actionButtons || []; track action.label) { @if (!action.visible || action.visible(item)) {
          <button
            class="item-browser__card-action-btn"
            [class.item-browser__card-action-btn--disabled]="action.disabled?.(item)"
            [disabled]="action.disabled?.(item)"
            (click)="onActionClick(action, item)"
            [title]="action.label"
            type="button">
            <ng-glyph [name]="action.icon" size="18"></ng-glyph>
            <span>{{ action.label }}</span>
          </button>
          } }
        </div>
      </div>
    </div>
    } }
  </div>

  <!-- Pagination (Top) -->
  @if (!config.loading && displayedData.length > 0) {
  <div class="item-browser__pagination">
    <div class="item-browser__pagination-info">
      Showing {{ (pagination.page - 1) * pagination.limit + 1 }} to {{ getEndRange() }} of {{ pagination.total }} entries
    </div>
    <div class="item-browser__pagination-controls">
      <button
        class="item-browser__pagination-btn"
        [disabled]="currentPage <= 1"
        (click)="onPageChange(currentPage - 1)"
        title="Previous page">
        <ng-glyph name="chevron_left" size="18"></ng-glyph>
      </button>

      @for (page of getPaginationRange(); track page) {
      <button
        class="item-browser__pagination-btn"
        [class.item-browser__pagination-btn--active]="page === currentPage"
        (click)="onPageChange(page)"
        [disabled]="page === currentPage">
        {{ page }}
      </button>
      }

      <button
        class="item-browser__pagination-btn"
        [disabled]="currentPage >= pagination.pages"
        (click)="onPageChange(currentPage + 1)"
        title="Next page">
        <ng-glyph name="chevron_right" size="18"></ng-glyph>
      </button>
    </div>
  </div>
  }
</div>
